import request from '@/utils/request'

export default {
    getList() {
        return request({
          url: '/app/pathList',
          method:'get'
        })
      },
      downloadios(url) {
        return request({
          url: `/app/sowPath?path=${url}`,
          method:'get'
        })
      },
}